<mat-form-field appearance="outline">
  <input type="text"
    placeholder="{{placeholder.length ? placeholder : label}}"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [matAutocompletePosition]="'below'"
  >
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{option}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>